import { render } from "./NovaContratacaoView.vue?vue&type=template&id=5048b2fe&scoped=true"
import script from "./NovaContratacaoView.vue?vue&type=script&lang=js"
export * from "./NovaContratacaoView.vue?vue&type=script&lang=js"

import "./NovaContratacaoView.vue?vue&type=style&index=0&id=5048b2fe&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5048b2fe"]])

export default __exports__